"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.gridItem = exports.gridContainer = void 0;

var _stylitas = require("@creditas/stylitas");

const gridContainer = ({
  container,
  justifyItems,
  alignItems,
  alignContent,
  rowGap
}) => container && (0, _stylitas.css)`
    display: grid;
    justify-items: ${justifyItems};
    align-items: ${alignItems};
    align-content: ${alignContent};

    ${(0, _stylitas.mq)({
  gridTemplateColumns: ['repeat(8, 1fr)', 'repeat(8, 1fr)', 'repeat(8, 1fr)', 'repeat(8, 1fr)', 'repeat(12, 1fr)', 'repeat(12, 1fr)'],
  gridColumnGap: ['8px', '8px', '8px', '16px', '24px', '24px'],
  gridRowGap: rowGap,
  padding: [[0, '20px'], [0, '20px'], [0, '24px'], [0, '40px'], [0, '71px'], [0, '252px']]
})}
  `;

exports.gridContainer = gridContainer;

const gridItem = ({
  item,
  colStart,
  colEnd,
  rowStart,
  rowEnd,
  justifySelf,
  alignSelf
}) => item && (0, _stylitas.css)`
    grid-column-start: ${colStart};
    grid-column-end: span ${colEnd};
    grid-row-start: ${rowStart};
    grid-row-end: span ${rowEnd};
    justify-self: ${justifySelf};
    align-self: ${alignSelf};
  `;

exports.gridItem = gridItem;